module.exports = __webpack_public_path__ + "static/graph1-bc440ccf162d3194fe27ab4e124b5284.png";